// Debug utilities for testing API connectivity
import { authAPI } from './api';

export const testAPIConnectivity = async () => {
  try {
    console.log('Testing API connectivity...');
    console.log('API URL:', process.env.REACT_APP_API_URL);
    
    // Test basic connectivity
    const response = await fetch(`${process.env.REACT_APP_API_URL?.replace('/api', '')}/health`, {
      method: 'GET',
      credentials: 'include'
    });
    
    const healthData = await response.json();
    console.log('Health check result:', healthData);
    
    // Test login with test user
    try {
      console.log('Testing login...');
      const loginResult = await authAPI.login('testuser', 'TestPass123!');
      console.log('Login successful:', loginResult);
      
      // Test session check
      console.log('Testing session check...');
      const sessionResult = await authAPI.getSession();
      console.log('Session check successful:', sessionResult);
      
      return { success: true, data: { health: healthData, login: loginResult, session: sessionResult } };
    } catch (loginError) {
      console.error('Login test failed:', loginError);
      return { success: false, error: loginError };
    }
    
  } catch (error) {
    console.error('API connectivity test failed:', error);
    return { success: false, error };
  }
};

// Add this to window for testing in browser console
(window as any).testAPI = testAPIConnectivity;